// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ju6P","image":"Header_image__30_JQ","name":"Header_name__2iEBm","info":"Header_info__1Db7R","infoRow":"Header_infoRow__49Xpu"};